import { styled } from 'styled-components';

export const ServiceProviderWarningMessageWrapper = styled.div.attrs({
  className: 'text-center',
  'data-testid': 'service-provider-warning-message',
})``;

export const ServiceProviderWarningStores = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: space-around;
  margin: 15px 0;

  svg,
  img {
    height: 40px;
  }

  a {
    display: flex;
    height: 40px;
  }
`;
